import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { usePushEventPreference } from '../hooks/usePushEventPreference'

const EVENT_TYPE = 'vision_post_created'

export default function VisionPostPushSettingsCard() {
  const { enabled, loading, saving, save } = usePushEventPreference(EVENT_TYPE)
  const { add: toast } = useToast()

  const checked = enabled !== null ? enabled : true
  const disabled = loading || saving || enabled === null

  async function onToggle(next: boolean) {
    const ok = await save(next)
    toast({
      title: 'Notificacoes - Visoes',
      description: ok ? (next ? 'Ativadas' : 'Desativadas') : 'Nao foi possivel salvar.',
      variant: ok ? 'success' : 'error',
      soft: ok,
    })
  }

  return (
    <Card>
      <CardHeader className="text-sm font-medium">Visoes</CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 items-start gap-4 md:grid-cols-2">
          <div>
            <div className="flex items-center gap-2">
              <Label>Desativado</Label>
              <Switch
                checked={checked}
                onChange={(e) => onToggle((e.target as HTMLInputElement).checked)}
                disabled={disabled}
              />
              <Label>Ativado</Label>
            </div>
            <div className="mt-2 text-sm text-foreground/80">
              Receba notificacao quando uma nova visao for publicada no feed (titulo + conteudo).
            </div>
            <div className="text-xs text-foreground/70">
              Respeita seus horarios/pausa e somente usuarios com acesso ao modulo recebem. Requer Notificacoes Push (PWA) ativadas acima.
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
